export default {
  title: "My Votings",
  loading: "Loading your votes...",
  emptyState: "You haven't cast any votes yet",
}
